// @flow
import type { ERROR_TYPE } from './common';

export type SCHOOL_TYPE = {
  id: number,
  name: string,
  address: string,
  phone: string
}

export type SCHOOL_FETCH_STARTED_TYPE = {
  type: 'SCHOOL_FETCH_STARTED',
  payload: number
};
export const SCHOOL_FETCH_STARTED = 'SCHOOL_FETCH_STARTED';

export type SCHOOL_SELECTED_TYPE = {
    type: 'SCHOOL_SELECTED',
    payload: number
};
export const SCHOOL_SELECTED = 'SCHOOL_SELECTED';

export type SCHOOL_FETCH_SUCCEED_TYPE = {
  type: 'SCHOOL_FETCH_SUCCEED',
  payload: SCHOOL_TYPE
};
export const SCHOOL_FETCH_SUCCEED = 'SCHOOL_FETCH_SUCCEED';

export type SCHOOL_FETCH_FAILED_TYPE = {
  type: 'SCHOOL_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const SCHOOL_FETCH_FAILED = 'SCHOOL_FETCH_FAILED';

export type SCHOOLS_REGISTERED_TYPE = {
  type: 'SCHOOLS_REGISTERED',
  payload: {
    entities: { [number]: SCHOOL_TYPE }
  }
};
export const SCHOOLS_REGISTERED = 'SCHOOLS_REGISTERED';

export type SCHOOL_ACTION_TYPE =
  | SCHOOL_FETCH_STARTED_TYPE
  | SCHOOL_SELECTED_TYPE
  | SCHOOL_FETCH_SUCCEED_TYPE
  | SCHOOL_FETCH_FAILED_TYPE
  | SCHOOLS_REGISTERED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/schools.js